import type {OpenGraphImage} from '../types/openGraph';

export const getDefaultOpenGraphImage = (): OpenGraphImage => ({
  url: '/images/open-graph-image.jpg',
  width: 1920,
  height: 540
});
